import { Settings } from 'constants/settings';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import colors from 'tailwindcss/colors';

const useDefaultColor = () => {
    const { settings } = useCurrentAccount();
    const themeColor = settings.find(item => item.code === Settings.ThemeColor.Code);

    return themeColor?.value || colors.blue['500'];
};

export { useDefaultColor };
